import * as React from 'react';
import SearchSuggestion from './SearchSuggestion';
import { KeywordSuggestion, SubstrateSearchSuggestionSegment } from 'owa-search-service';
import { observer } from 'mobx-react-lite';
import { PeopleSegment } from './segmentedSuggestion/PeopleSegment';
import { SearchScenarioId } from '../../store/schema/SearchScenarioId';
import { SMALL_SUGGESTION_HEIGHT } from '../../searchConstants';
import { TextSegment } from './segmentedSuggestion/TextSegment';

const styles = require('./SegmentedSearchSuggestion.scss');

export interface SegmentedSearchSuggestionProps {
    index: number;
    scenarioId: SearchScenarioId;
    suggestion: KeywordSuggestion;
    suggestionSetTraceId: string;
}

const SegmentedSearchSuggestion = observer(function SegmentedSearchSuggestion(
    props: SegmentedSearchSuggestionProps
) {
    const { index, scenarioId, suggestion, suggestionSetTraceId } = props;

    const style: React.CSSProperties = {
        lineHeight: `${SMALL_SUGGESTION_HEIGHT}px`,
    };

    return (
        <SearchSuggestion
            ariaLabel={suggestion.DisplayText}
            content={
                <div className={styles.container} style={style}>
                    {suggestion.Segments.map((segment: SubstrateSearchSuggestionSegment) => {
                        if (segment.Type === 'Person') {
                            return <PeopleSegment segment={segment} />;
                        } else if (segment.Type === 'Text') {
                            return <TextSegment segment={segment} />;
                        }

                        return null;
                    })}
                </div>
            }
            suggestion={suggestion}
            scenarioId={scenarioId}
            suggestionSetTraceId={suggestionSetTraceId}
            index={index}
        />
    );
});
export default SegmentedSearchSuggestion;
